/**
 * Labstep
 */

import { PostFilter } from 'labstep-web/services/postFilter';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';

export const PostFilterStatusTypeUnstarted = new PostFilter([
  ['started_at', PostFilterComparison.null],
  ['ended_at', PostFilterComparison.null],
]);

export const PostFilterStatusTypeStarted = new PostFilter([
  ['started_at', PostFilterComparison.not_null],
  ['ended_at', PostFilterComparison.null],
]);

export const PostFilterStatusTypeCompleted = new PostFilter([
  ['started_at', PostFilterComparison.not_null],
  ['ended_at', PostFilterComparison.not_null],
]);
